import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

// IMPORT PACKAGE REFERENCES

import { searchPharmacies, sortPharmacies, filterPharmacies } from '../State/Actions/PharmacyActions';
import { FilterType } from './FilterType';
import { SortType } from './SortType';
import { DirectionType } from './DirectionType';


// COMPONENT

class PharmacySidebar extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            searchText: '',
            activeSort: SortType.ALPHABETICALLY,
            activeDirection: DirectionType.ASCENDING,
            activeFilter: FilterType.ALL,
        };
    }

    
    filterClicked(filterType) {
        this.props.filterPharmacies(filterType);
    }

    componentWillReceiveProps(nextProps) {
        let activeSort = this.state.activeSort;
        let activeDirection = this.state.activeDirection;
        let activeFilter = this.state.activeFilter;

        if (nextProps.activeSort !== undefined) {
            activeSort = nextProps.activeSort;
        }

        if (nextProps.activeDirection !== undefined) {
            activeDirection = nextProps.activeDirection;
        }

        if (nextProps.activeFilter !== undefined) {
            activeFilter = nextProps.activeFilter;
        }

        this.setState({ activeSort, activeDirection, activeFilter })
    }


    sortClicked(sortType) {
        this.props.sortPharmacies(sortType, this.state.activeDirection);
    }

    directionClicked(directionType) {
        this.props.sortPharmacies(this.state.activeSort, directionType);
    }

    render() {
        return (
            <div className="sidebar">
                <div className="sidebar-section-header">Sort Pharmacies</div>
                <div className={"sidebar-section-option " + ((this.state.activeSort === SortType.ALPHABETICALLY) && "active") } onClick={() => this.sortClicked(SortType.ALPHABETICALLY)} >Alphabetically</div>
                <div className={"sidebar-section-option " + ((this.state.activeSort === SortType.MDM_ID) && "active") } onClick={() => this.sortClicked(SortType.MDM_ID)} >MDM ID</div>
                <div className={"sidebar-section-option " + ((this.state.activeSort === SortType.LAST_ACTIVE) && "active") } onClick={() => this.sortClicked(SortType.LAST_ACTIVE)} >Last Active</div>
                <div className={"sidebar-section-option " + ((this.state.activeSort === SortType.LAST_REPORT) && "active") } onClick={() => this.sortClicked(SortType.LAST_REPORT)} >Last Report</div>
                <div className={"sidebar-section-option " + ((this.state.activeSort === SortType.LAST_TOUCHED) && "active") } onClick={() => this.sortClicked(SortType.LAST_TOUCHED)} >Last Touched</div>
                <div className="sidebar-section-header">Sort Direction</div>
                <div className={"sidebar-section-option " + ((this.state.activeDirection === DirectionType.ASCENDING) && "active") } onClick={() => this.directionClicked(DirectionType.ASCENDING)} >Ascending</div>
                <div className={"sidebar-section-option " + ((this.state.activeDirection === DirectionType.DESCENDING) && "active") } onClick={() => this.directionClicked(DirectionType.DESCENDING)} >Descending</div>

                <div className="sidebar-section-header">Filter</div>
                <div className={"sidebar-section-option " + ((this.state.activeFilter === FilterType.ALL) && "active") }  onClick={() => this.filterClicked(FilterType.ALL)} >All</div>
                <div className={"sidebar-section-option " + ((this.state.activeFilter === FilterType.ASSOCIATED) && "active") }  onClick={() => this.filterClicked(FilterType.ASSOCIATED)} >Attached</div>
                <div className={"sidebar-section-option " + ((this.state.activeFilter === FilterType.UNASSOCIATED) && "active") }  onClick={() => this.filterClicked(FilterType.UNASSOCIATED)} >Unattached</div>
                <div className={"sidebar-section-option " + ((this.state.activeFilter === FilterType.TESTING) && "active") }  onClick={() => this.filterClicked(FilterType.TESTING)} >Test</div>
                <div className={"sidebar-section-option " + ((this.state.activeFilter === FilterType.DEACTIVATED) && "active") }  onClick={() => this.filterClicked(FilterType.DEACTIVATED)} >Deactivated</div>
                <div className={"sidebar-section-option " + ((this.state.activeFilter === FilterType.REQUIRES_ATTENTION) && "active") }  onClick={() => this.filterClicked(FilterType.REQUIRES_ATTENTION)} >Requires Attention</div>
            </div>
        )
    }
}


// CONFIGURE REACT REDUX
const mapStateToProps = state => {
  const { activeFilter, activeSort, activeDirection } = state.pharmaciesReducer;
  return { activeFilter, activeSort, activeDirection };
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({ searchPharmacies, sortPharmacies, filterPharmacies }, dispatch)
);

const hoc = connect(mapStateToProps, mapDispatchToProps)(PharmacySidebar);


// EXPORT COMPONENT

export { hoc as PharmacySidebar };